import CityPageTemplate from "../city-template/CityPageTemplate";
import { antiochConfig } from "./data";

export default function AntiochPage() {
  return <CityPageTemplate config={antiochConfig} />;
}